import { GenericLazyString } from '@eventbrite/i18n';
import { Location } from 'history';
import React, { ReactElement } from 'react';
import { formatUrl } from 'url-lib';
import {
    CarouselHeader,
    CarouselTitle,
} from '../SimpleCarousel/components/CarouselHeader';
import { CarouselNavigation } from '../SimpleCarousel/components/CarouselNavigation';
import { NavDirections, SlideConfig } from '../SimpleCarousel/types';
import { OrganizerList } from './components/OrganizerList';
import './OrganizerCarousel.scss';

interface OrganizerCarouselProps {
    headerTitle?: string | GenericLazyString | ReactElement;
    organizerIds: string[];
    pageArea: string;
    useSideNavigation?: boolean;
    slidesVisible?: SlideConfig;
    location: Location;
    publicId?: string;
    isAuthenticated?: boolean;
}

export const OrganizerCarousel: React.FunctionComponent<
    OrganizerCarouselProps
> = (props) => {
    const {
        headerTitle,
        organizerIds,
        pageArea,
        slidesVisible = { desktop: 6, tablet: 2 },
        location,
    } = props;

    const [disabledNav, setDisabledNav] = React.useState<
        NavDirections | undefined
    >(NavDirections.Left);
    const scrollContainerRef = React.useRef<HTMLUListElement>(null);

    const handleScroll = (direction: NavDirections) => {
        const containerWidth = scrollContainerRef.current?.clientWidth || 0;
        const normalizedContainerWidth = containerWidth * 0.9 || 200;
        const scrollAmount =
            direction === NavDirections.Right
                ? normalizedContainerWidth
                : normalizedContainerWidth * -1;
        scrollContainerRef?.current?.scrollBy({
            left: scrollAmount,
            behavior: 'smooth',
        });
    };

    return (
        <>
            <CarouselHeader>
                <CarouselTitle>{headerTitle}</CarouselTitle>
                {!props.useSideNavigation ? (
                    <CarouselNavigation
                        childrenLength={organizerIds.length}
                        slidesVisible={slidesVisible}
                        handleClick={handleScroll}
                        leftDisabled={disabledNav === NavDirections.Left}
                        rightDisabled={disabledNav === NavDirections.Right}
                    />
                ) : null}
            </CarouselHeader>
            <section style={{ minHeight: '250px' }}>
                <ul
                    className="category-browse__organizer-follow"
                    ref={scrollContainerRef}
                >
                    <OrganizerList
                        organizers={organizerIds}
                        userId={props?.publicId}
                        isAuthenticated={props?.isAuthenticated}
                        isGDPRCountry={true}
                        loginOptions={{
                            referrer: formatUrl(
                                `${location.pathname}${location.search}`,
                            ),
                        }}
                        setDisabledNav={setDisabledNav}
                        pageArea={pageArea}
                    />
                </ul>
            </section>
        </>
    );
};
